import { makeAutoObservable } from 'mobx';

class RowViewModel {
  data;
  parent;
  isExpanded = false;
  isLoading = false;

  constructor(data, parent = null) {
    makeAutoObservable(this);

    this.data = data;
    this.parent = parent;
  }

  expand() {
    this.isExpanded = true;
  }

  collapse() {
    this.isExpanded = false;
  }

  setLoading(loading) {
    this.isLoading = loading;
  }
}

export default RowViewModel;
